module.exports = __webpack_public_path__ + "static/img/logo.489eb45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/logo.png
// module id = INtC
// module chunks = 1